import { render, staticRenderFns } from "./Recetas.vue?vue&type=template&id=ce109fc4"
import script from "./Recetas.vue?vue&type=script&lang=js"
export * from "./Recetas.vue?vue&type=script&lang=js"
import style0 from "./Recetas.vue?vue&type=style&index=0&id=ce109fc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports